import { cn } from '@heidi/utils';

import { typographyVariant } from '../typography';

export const drawerOverlayClasses = 'fixed inset-0 z-50 bg-overlay';

export const drawerContentPortalPositionClasses = 'absolute inset-x-0 bottom-0 z-[101]';

export const drawerContentFixedPositionClasses = 'fixed inset-x-0 bottom-0 z-50';

export const drawerContentBaseClasses =
  'mt-24 flex h-auto max-h-[90%] flex-col rounded-t-[10px] border bg-surface';

export const drawerCloseIconClasses =
  'mx-auto mt-4 h-2 w-[100px] rounded-full bg-background-secondary';

export const drawerHeaderClasses = 'grid gap-1.5 p-4 text-center sm:text-start';

export const drawerFooterClasses = 'mt-auto flex flex-col gap-2 p-4';

export const drawerTitleClasses = typographyVariant({ variant: 'h4' });

export const drawerDescriptionClasses = cn(
  typographyVariant({ variant: 'p2' }),
  'text-text-secondary'
);
